"use strict";
import axios from 'axios'
import qs from 'qs'

axios.interceptors.request.use(function (config) {
    let token = localStorage.getItem("usertoken");
    if (token == undefined) {
        token = "";
    }
    config.headers.Authorization = "Bearer "+token;
    if (config.method === 'post' || config.method === 'put' || config.method === 'patch') {
        if(config.url.indexOf("api") != -1 ) {
          config.data = qs.stringify(config.data);
        }
      }
    return config;
}, function (error) {
    return Promise.reject(error);
});
// export const uri = 'http://gl.xiaojinku12345.com';
// export const uri = 'http://localhost:5001';
export const uri = ''; 


//扩展任务相关
export const taskOtherGet = (params, callback) => get('/TaskOther/Get', params, callback);
export const taskOtherSave = (params, callback) => post('/TaskOther/Save', params, callback);
export const taskOtherSaveStep = (params, callback) => post('/TaskOther/SaveStep', params, callback);

export const taskOtherGetOrder = (params, callback) => get('/TaskOther/GetOrder', params, callback);
export const taskOtherReview = (params, callback) => get('/TaskOther/Review', params, callback);
export const taskOtherChangeSumbit = (params, callback) => get('/TaskOther/ChangeSumbit', params, callback);
export const taskOtherCanel = (params, callback) => get('/TaskOther/Canel', params, callback);


export const statisticsGetDaily = (params, callback) => get('/api/Statistics/GetDaily', params, callback);
export const statisticsSaveRemark = (params, callback) => get('/api/Statistics/SaveRemark', params, callback);

export const reimbursementGet = (params, callback) => get('/Reimbursement/Get', params, callback);
export const reimbursementAdd = (params, callback) => post('/Reimbursement/Add', params, callback);

//兼职人员
export const outsiderGetSel = (params, callback) => get('/Outsider/GetSel', params, callback);

export const outsiderSave = (params, callback) => post('/Outsider/Save', params, callback);

export const outsiderRecharge = (params, callback) => get('/Outsider/Recharge', params, callback);
export const outsiderGetRecord = (params, callback) => get('/Outsider/GetRecord', params, callback);


//首页
export const indexGetActiveSwipeChart = (params, callback) => get('/Index/GetActiveSwipeChart', params, callback);
export const indexGetSwipeChart = (params, callback) => get('/Index/GetSwipeChart', params, callback);
export const indexGetAccountsChart = (params, callback) => get('/Index/GetAccountsChart', params, callback);



//收款卡配置
export const receivePaymentGet = (params, callback) => get('/ReceivePayment/Get', params, callback);
export const receivePaymentSave = (params, callback) => post('/ReceivePayment/Save', params, callback);
export const receivePaymentGetAlipay = (params, callback) => get('/ReceivePayment/GetAlipay', params, callback);
export const receivePaymentSaveAlipay = (params, callback) => post('/ReceivePayment/SaveAlipay', params, callback);




//人员相关
export const loging = (params, callback) => get('/Manager/Login', params, callback);
export const manageGet = (params, callback) => get('/Manager/Get', params, callback);
export const manageDel = (params, callback) => get('/Manager/Del', params, callback);
export const manageSave = (params, callback) => post('/Manager/Save', params, callback);
export const manageGetConfig = (params, callback) => get('/Manager/GetConfig', params, callback);

export const manageSaveCard = (params, callback) => post('/Manager/SaveCard', params, callback);
export const manageSaveConfig = (params, callback) => post('/Manager/SaveConfig', params, callback);

export const manageGetIndex = (params, callback) => get('/Manager/GetIndex', params, callback);
export const manageGetReport = (params, callback) => get('/Manager/GetReport', params, callback);
export const managerGetSel = (params, callback) => get('/Manager/GetSel', params, callback);
export const managerGetIsOnline = (params, callback) => get('/Manager/GetIsOnline', params, callback);
export const managerSetIsOnLine = (params, callback) => get('/Manager/SetIsOnLine', params, callback);


//佣金模板相关
export const commissionGet = (params, callback) => get('/Commission/Get', params, callback);
export const commissionDel = (params, callback) => get('/Commission/Del', params, callback);
export const commissionAdd = (params, callback) => post('/Commission/Add', params, callback);
export const commissionGetAll = (params, callback) => get('/Commission/GetAll', params, callback);
export const commissionGetDetails = (params, callback) => get('/Commission/GetDetails', params, callback);
//店铺相关
export const shopGet = (params, callback) => get('/Shop/Get', params, callback);
export const shopOver = (params, callback) => get('/Shop/Over', params, callback);
export const shopPass = (params, callback) => get('/Shop/Pass', params, callback);
export const shopClose = (params, callback) => get('/Shop/Close', params, callback);
export const shopEnable = (params, callback) => get('/Shop/Enable', params, callback);
export const configGetCategory = (params, callback) => get('/Config/GetCategory', params, callback);
export const shopQuery = (params, callback) => get('/Shop/Query', params, callback);
export const SetShopConfig = (params, callback) => post('/Shop/SetShopConfig', params, callback);

//用户相关
export const memberGet = (params, callback) => get('/Member/Get', params, callback);
export const memberSetStatus = (params, callback) => get('/Member/SetStatus', params, callback);
export const memberSetReferrer = (params, callback) => get('/Member/SetReferrer', params, callback);
export const memberSetReferrerExtra = (params, callback) => get('/Member/SetReferrerExtra', params, callback);
export const memberClearReferrer = (params, callback) => get('/Member/ClearReferrer', params, callback);
export const memberClearReferrerExtra = (params, callback) => get('/Member/ClearReferrerExtra', params, callback);
export const memberOpenCredits = (params, callback) => get('/Member/OpenCredits', params, callback);
export const memberCloseCredits = (params, callback) => get('/Member/CloseCredits', params, callback);
export const memberAddBalance = (params, callback) => get('/Member/AddBalance', params, callback);
export const memberReduceBalance = (params, callback) => get('/Member/ReduceBalance', params, callback);

export const memberAddPayout = (params, callback) => get('/Member/AddPayout', params, callback);
export const memberReducePayout = (params, callback) => get('/Member/ReducePayout', params, callback);
export const memberSetCommission = (params, callback) => get('/Member/SetCommission', params, callback);
export const memberGetOffline = (params, callback) => get('/Member/GetOffline', params, callback);

export const memberSetReceivePayment = (params, callback) => get('/Member/SetReceivePayment', params, callback);
export const memberSetReceiveAlipay = (params, callback) => get('/Member/SetReceiveAlipay', params, callback);

export const memberGetMemberData = (params, callback) => get('/Member/GetMemberData', params, callback);
export const memberSetRemark = (params, callback) => get('/Member/SetRemark', params, callback);
export const swipeClearScript = (params, callback) => get('/Member/ClearScript', params, callback);

//公告相关
export const announcementGet = (params, callback) => get('/Announcement/Get', params, callback);
export const announcementAdd = (params, callback) => post('/Announcement/Add', params, callback);
export const announcementDel = (params, callback) => get('/Announcement/Del', params, callback);

//财务相关
export const transactionGet = (params, callback) => get('/Transaction/Get', params, callback);
export const transactionPass = (params, callback) => get('/Transaction/Pass', params, callback);
export const transactionOver = (params, callback) => get('/Transaction/Over', params, callback);
export const recordGet = (params, callback) => get('/Transaction/GetRecord', params, callback);
export const transactionHasReview = (params, callback) => get('/Transaction/HasReview', params, callback);

//任务相关
export const taskBatchGet = (params, callback) => get('/TaskBatch/Get', params, callback);


export const taskBatchPass = (params, callback) => get('/TaskBatch/Pass', params, callback);
export const taskBatchOver = (params, callback) => get('/TaskBatch/Over', params, callback);
export const taskGetDetail = (params, callback) => get('/TaskBatch/GetDetail', params, callback);
export const taskGetDetailChild = (params, callback) => get('/TaskBatch/GetDetailChild', params, callback);
export const taskOverTask = (params, callback) => get('/TaskBatch/OverTaskNew', params, callback);

export const taskOverTaskNoDetail = (params, callback) => get('/TaskBatch/OverTaska', params, callback);
export const taskEdit = (params, callback) => get('/TaskBatch/Edit', params, callback);
export const taskGetOrder = (params, callback) => get('/TaskBatch/GetOrder', params, callback);

export const shopGetReport = (params, callback) => get('/TaskBatch/GetShopReport', params, callback);
export const memberGetReport = (params, callback) => get('/TaskBatch/GetMemberReport', params, callback);
export const taskSetExpectedOverTime = (params, callback) => get('/TaskBatch/SetExpectedOverTime', params, callback);

export const taskAbandoned = (params, callback) => get('/TaskBatch/Abandoned', params, callback);


export const taskSetTitle = (params, callback) => get('/TaskBatch/SetTitle', params, callback);
export const taskSetChildTitle = (params, callback) => get('/TaskBatch/SetChildTitle', params, callback);
export const taskSetUrl = (params, callback) => get('/TaskBatch/SetUrl', params, callback);
export const taskSetChildUrl = (params, callback) => get('/TaskBatch/SetChildUrl', params, callback);
export const taskSetRequirement = (params, callback) => get('/TaskBatch/SetRequirement', params, callback);
export const taskExistOrder = (params, callback) => post('/TaskBatch/ExistOrder', params, callback);
export const taskExistDetail = (params, callback) => post('/TaskBatch/ExistDetail', params, callback);
export const taskExistDetailNoMatch = (params, callback) => post('/TaskBatch/ExistDetailNoMatch', params, callback);


//刷手相关
export const swipeGet = (params, callback) => get('/Swipe/Get', params, callback);
export const swipeGetDevice = (params, callback) => get('/Swipe/GetDevice', params, callback);
export const swipeFail = (params, callback) => get('/Swipe/Fail', params, callback);
export const swipeRecertification = (params, callback) => get('/Swipe/Recertification', params, callback);

export const swipePass = (params, callback) => get('/Swipe/Pass', params, callback);
export const swipeGetCertificationData = (params, callback) => get('/Swipe/GetCertificationData', params, callback);
export const swipeDisable = (params, callback) => get('/Swipe/Disable', params, callback);
export const swipeEnable = (params, callback) => get('/Swipe/Enable', params, callback);
export const swipeGetContact = (params, callback) => get('/Swipe/GetContact', params, callback);
export const swipeGetChild = (params, callback) => get('/Swipe/GetChild', params, callback);
export const swipeAdd = (params, callback) => get('/Swipe/Add', params, callback);
export const swipeSetIsOld = (params, callback) => get('/Swipe/SetIsOld', params, callback);
export const swipeSetStatus = (params, callback) => get('/Swipe/SetStatus', params, callback);
export const swipeUpdateCertification = (params, callback) => get('/Swipe/UpdateCertification', params, callback);
export const swipeSetAssist = (params, callback) => get('/Swipe/SetAssist', params, callback);
export const swipeBindWechat = (params, callback) => get('/Swipe/BindWechat', params, callback);
export const swipeSetQQgroup = (params, callback) => get('/Swipe/SetQQgroup', params, callback);
export const swipeGetRepeatContact = (params, callback) => get('/Swipe/GetRepeatContact', params, callback);
export const swipeGetProve = (params, callback) => get('/Swipe/GetProve', params, callback);
export const swipeSetProve = (params, callback) => get('/Swipe/SetProve', params, callback);
export const swipeSetGrade = (params, callback) => get('/Swipe/SetGrade', params, callback);

export const swipeSwipeNoOrder = (params, callback) => get('/Swipe/SwipeNoOrder', params, callback);
export const swipeGetNoOrder = (params, callback) => get('/Swipe/GetNoOrder', params, callback);
export const swipeSetHasPromote = (params, callback) => get('/Swipe/SetHasPromote', params, callback);


//派单相关
export const orderUndo = (params, callback) => get('/Order/Undo', params, callback);

// export const dispatchGetSwipe = (params, callback) => get('/Dispatch/GetSwipe', params, callback);
export const orderSetProblem = (params, callback) => post('/Order/SetProblem', params, callback);
export const orderAssignOrder = (params, callback) => get('/Order/AssignOrder', params, callback);
export const orderGetImgs = (params, callback) => get('/Order/GetImgs', params, callback);
export const orderPayPrincipal = (params, callback) => get('/Order/PayPrincipal', params, callback);
export const orderOverPrincipal = (params, callback) => get('/Order/OverPrincipal', params, callback);

export const orderOver = (params, callback) => get('/Order/Over', params, callback);
export const orderPass = (params, callback) => get('/Order/Pass', params, callback);
export const orderGetSwipe = (params, callback) => get('/Order/GetSwipe', params, callback);
export const orderBatchAssign = (params, callback) => post('/Order/BatchAssign', params, callback);
export const orderGetPayOrder = (params, callback) => get('/Order/GetPayOrder', params, callback);
export const orderPayOrder = (params, callback) => get('/Order/PayOrder', params, callback);

export const orderAddOrder = (params, callback) => get('/Order/AddOrder', params, callback);
export const orderCancelOrder = (params, callback) => get('/Order/CancelOrder', params, callback);

export const orderAdd = (params, callback) => post('/Order/Add', params, callback);

export const orderInvalid = (params, callback) => get('/Order/Invalid', params, callback);
export const orderCanelInvalid = (params, callback) => get('/Order/CanelInvalid', params, callback);

export const orderSetPrice = (params, callback) => get('/Order/SetPrice', params, callback);
export const orderUpdateOrderCode = (params, callback) => get('/Order/UpdateOrderCode', params, callback);
export const orderCancelPayOrder = (params, callback) => get('/Order/CancelPayOrder', params, callback);
export const orderSetKey = (params, callback) => get('/Order/SetKey', params, callback);
export const orderSetSwipeRemark = (params, callback) => get('/Order/SetSwipeRemark', params, callback);
export const orderOkOrder = (params, callback) => get('/Order/OkOrder', params, callback);
export const orderSetOrderAbnormal = (params, callback) => get('/Order/SetOrderAbnormal', params, callback);
export const orderGetKanBan = (params, callback) => get('/Order/GetKanBan', params, callback);
export const orderRedistribute = (params, callback) => get('/Order/Redistribute', params, callback);

export const orderSetAdvanceMoney = (params, callback) => get('/Order/SetAdvanceMoney', params, callback);
export const orderOperatingIncome = (params, callback) => get('/Order/OperatingIncome', params, callback);
export const orderGetJiangQuanOrder = (params, callback) => post('/Order/GetJiangQuanOrder', params, callback);
export const orderGetJiangQuanOrderExl = (params, callback) => 
axios({ // 用axios发送post请求
  method: 'post',
  url: uri + '/Order/GetJiangQuanOrderExl', // 请求地址
  data: qs.stringify(params), // 参数
  responseType: 'blob' // 表明返回服务器返回的数据类型
}).then(res => {
  callback(res.data);
});

//刷手财务
export const swipeBillGet = (params, callback) => get('/SwipeBill/Get', params, callback);
export const swipeBillReview = (params, callback) => get('/SwipeBill/Review', params, callback);
export const swipeBillGetRecord = (params, callback) => get('/SwipeBill/GetRecord', params, callback);
export const swipeGetMyWithdraw = (params, callback) => get('/SwipeBill/GetMyWithdraw', params, callback);
export const swipePassBatch = (params, callback) => get('/SwipeBill/PassBatch', params, callback);
export const swipeAssign = (params, callback) => get('/SwipeBill/Assign', params, callback);

export const swipeBillGetKanBan = (params, callback) => get('/SwipeBill/GetKanBan', params, callback);
export const swipeBillSetIsOnLine = (params, callback) => get('/SwipeBill/SetIsOnLine', params, callback);
export const swipeModifyBalance = (params, callback) => post('/Swipe/SwipeModifyBalance', params, callback);

//基础数据
export const qqGroupGet = (params, callback) => get('/api/QqGroup/GetSel', params, callback);

//反馈
export const orderGetFeedbackOrder = (params, callback) => get('/Order/GetFeedbackOrder', params, callback);
export const orderFeedbackOrder = (params, callback) => get('/Order/FeedbackOrder', params, callback);
export const swipeGetFeedback = (params, callback) => get('/Swipe/GetFeedback', params, callback);
export const swipeSendMsg = (params, callback) => get('/Swipe/SendMsg', params, callback);
export const swipeReplyFeedback = (params, callback) => get('/Swipe/ReplyFeedback', params, callback);

//好评
export const orderGetNeedPraiseOrder = (params, callback) => get('/Order/GetNeedPraiseOrder', params, callback);
export const orderPraiseOrderPass = (params, callback) => get('/Order/PraiseOrderPass', params, callback);
export const orderPraiseOrderFail = (params, callback) => get('/Order/PraiseOrderFail', params, callback);
export const orderPraiseOrderCanle = (params, callback) => get('/Order/PraiseOrderCanle', params, callback);
export const orderGetPraiseChild = (params, callback) => get('/Order/GetPraiseChild', params, callback);


//管理员微信
export const managerWechatGet = (params, callback) => get('/ManagerWechat/Get', params, callback);
export const managerWechatSwipeBind = (params, callback) => get('/ManagerWechat/SwipeBind', params, callback);
//绩效
export const managerReportGet = (params, callback) => get('/ManagerReport/Get', params, callback);
export const managerReportGetGroup = (params, callback) => get('/ManagerReport/GetGroup', params, callback);
//排单相关
export const taskBatchGetExpected = (params, callback) => get('/TaskBatch/GetExpected', params, callback);
export const taskBatchAssign = (params, callback) => get('/TaskBatch/Assign', params, callback);
export const taskGroupGetArrangement = (params, callback) => get('/TaskGroup/GetArrangement', params, callback);
export const taskGroupGetProcess = (params, callback) => get('/TaskGroup/GetProcess', params, callback);
export const taskGroupGetManagerTask = (params, callback) => get('/TaskGroup/GetManagerTask', params, callback);
export const taskGroupRedistribute = (params, callback) => get('/TaskGroup/Redistribute', params, callback);
export const taskGroupEnd = (params, callback) => get('/TaskGroup/End', params, callback);
export const taskGroupAssignAuto = (params, callback) => get('/TaskGroup/AssignAuto', params, callback);
export const taskGroupFullyAuto = (params, callback) => get('/TaskGroup/FullyAuto', params, callback);
export const taskGroupStopFullyAuto = (params, callback) => get('/TaskGroup/StopFullyAuto', params, callback);
export const taskGroupChangeIsPause = (params, callback) => get('/TaskGroup/ChangeIsPause', params, callback);
export const taskGroupSetEndTime = (params, callback) => get('/TaskGroup/SetEndTime', params, callback);
export const taskGroupChangeType = (params, callback) => get('/TaskGroup/ChangeType', params, callback);


//新版派单

export const dispatchGetDetail = (params, callback) => get('/Dispatch/GetDetail', params, callback);
export const dispatchBatchAssign = (params, callback) => get('/Dispatch/BatchAssign', params, callback);
export const dispatchGetSwipe = (params, callback) => get('/Dispatch/GetSwipe', params, callback);
//兼职相关
export const outsiderGet = (params, callback) => get('/Outsider/Get', params, callback);


//上传主图
export const pushMain= (shopId,name,file,callback)=> {   // 上传照片
    console.log(shopId);
    console.log(name);
    let param = new FormData()  // 创建form对象
    param.append('file', file)  // 通过append向form对象添加数据
    let config = {
      headers: {'Content-Type': 'multipart/form-data'}
    }
   // 添加请求头
    axios.post(uri+'/Order/PushMain?shopId='+shopId+"&name="+name, param, config)
      .then(res => {
        callback(res.data);
      })
  }
export const get = (api, params, callback) => axios.get(uri + api, {
    params: params
}).then(res => {
    callback(res.data);
});

export const post = (api, params, callback) => axios.post(uri + api, qs.stringify(params))
.then(res => {
    callback(res.data);
});
export default axios;